import { Component, ElementRef, ViewChild } from '@angular/core';
import { finalize, take } from 'rxjs/operators';
import { MessageComponent } from '../shared/component/message/message.component';
import { AiService } from '../shared/service/ai.service';
import { AiChatService } from './services/ai-chat.service';
import { AiChatMessage } from './models/ai-message.model';
import { AiResponse } from './types/ai-response.type';

@Component({
  selector: 'app-ai-chat',
  templateUrl: './ai-chat.component.html',
  styleUrls: ['./ai-chat.component.css']
})
export class AiChatComponent {

  @ViewChild(MessageComponent) notification: MessageComponent;

  @ViewChild('aiChatContainer') aiChatContainerRef: ElementRef;

  messageContent: string = '';

  isAwaitingReply: boolean = false;

  readonly messages$ = this.aiChatService.messages$;

  constructor(
    private readonly aiService: AiService,
    private readonly aiChatService: AiChatService,
  ) {}

  sendMessage(event?: any) {
    if (event) {
      event.preventDefault();
    }
    
    const content = this.messageContent.trim();
    if (!content.length) return;

    const message: AiChatMessage = {
      id: Date.now().toString(),
      content: content,
      role: 'user',
      timestamp: new Date(),
    };

    if (this.isAwaitingReply) return;
    this.isAwaitingReply = true;
    
    this.aiChatService.addMessage(message);
    
    this.messageContent = '';
    this.scrollToBottom();
    
    const chatId = this.aiChatService.getChatId();

    this.aiService.interact(content, chatId).pipe(
      take(1),
      finalize(() => this.isAwaitingReply = false)
    ).subscribe((response: AiResponse) => {
      const messages: AiChatMessage[] = response.messages.map((rm) => {
        return {
          id: Date.now().toString(),
          content: this.sanitizeContent(rm.content),
          role: rm.role,
          timestamp: new Date(),
          actions: rm.actions,
        };
      });

      this.aiChatService.addMessage(messages);
      this.aiChatService.setChatId(response.chatId);
      this.scrollToBottom();
    },
    (err: any) => {
      this.notification.error('Erro ao interagir, tente novamente');
      console.log('err on interact:', err);
    });
  }

  private scrollToBottom() {
    const element = this.aiChatContainerRef;
    if (!element) return;
    requestAnimationFrame(() => {
      element.nativeElement.scrollTop = element.nativeElement.scrollHeight;
    });
  }

  private sanitizeContent(content: string): string {
    const escaped = content  
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(
        /\b((https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}[^\s<]*)/g,
        (match) => {
          try {
            const hasProtocol = match.startsWith('http://') || match.startsWith('https://');
            const fullUrl = hasProtocol ? match : `https://${match}`;

            const parsed = new URL(fullUrl);

            let display =
              parsed.host +
              parsed.pathname +
              parsed.search +
              parsed.hash;

            if (display.endsWith('/')) {
              display = display.slice(0, -1);
            }

            return `<a href="${fullUrl}" target="_blank" rel="noopener noreferrer">&nbsp;<u>${display}</u>&nbsp;</a>`;
          } catch (e) {
            return match;
          }
        }
      )
      .replace(/\n/g, '<br>');

    return escaped;
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/ai-chat/ai-chat.component.ts